import {createApp} from 'vue';
import App from "@/App.vue";
import {BootstrapVue3, BToastPlugin} from 'bootstrap-vue-3'
import VueEasyLightbox from "vue-easy-lightbox";
import DatePicker from 'vue3-datepicker';
import VueSelect from 'vue3-select2-component'
import VueTelInput from 'vue3-tel-input'
import Antd from 'ant-design-vue';
import Vue3Autocounter from 'vue3-autocounter';
import VueApexCharts from "vue3-apexcharts";
import Echo from './echo';
import {cookies} from "@/util";

import './http';

if (cookies.get('chat_api_token')) {
    Echo.init();
}

import eventHub from './event-hub';

// *************** Frontend Layout Components ***************
import SidebarWrapper from '@/views/frontend/layouts/sidebar-wrapper.vue'
import SideMenu from '@/views/frontend/layouts/side-menu.vue'
import ChatSidebar from '@/views/frontend/layouts/chat-sidebar.vue'
import OperatorSidebar from '@/views/frontend/layouts/operator-sidebar.vue'
import SettingsSidebar from '@/views/frontend/layouts/settings-sidebar.vue'

// *************** Admin Layout  ***************
import Admin_Header from '@/views/admin/layouts/header.vue'
import Admin_Sidebar from '@/views/admin/layouts/sidebar.vue'
import SideSettings from '@/views/admin/layouts/side-settings.vue'

// *************** Frontend Page Components ***************
import ChatContent from '@/views/frontend/pages/chat/chat-content.vue'
import ChatEmoji from '@/views/frontend/pages/chat/emoji.vue'
import ChatImage from '@/views/frontend/pages/chat/chat-images.vue'
import ChatSelectMenu from '@/views/frontend/pages/chat/chat-select-menu.vue'
import ChatRightSelectMenu from '@/views/frontend/pages/chat/chat-right-select-menu.vue'
import ChatRightSidebar from '@/views/frontend/pages/chat/chat-right-sidebar.vue'
import ChatRightImage from '@/views/frontend/pages/chat/chat-right-image.vue'
import ChatRightVideo from '@/views/frontend/pages/chat/chat-right-video.vue'
import SettingsContent from '@/views/frontend/pages/settings/settings-content.vue'
import EmojiType from '@/views/frontend/pages/chat/emoji-type.vue'
import ClickMenu from '@/views/frontend/pages/chat/click-menu.vue'
import ChatStarMessage from '@/views/frontend/pages/chat/chat-star-message.vue'
import MessageRightSidebar from '@/views/frontend/pages/chat/message-right-sidebar.vue'
import MessageInfoImg from '@/views/frontend/pages/chat/message-info-img.vue'
import SettingsSelectMenu from '@/views/frontend/pages/settings/settings-select-menu.vue'
import RightSidebarWrapper from "@/views/frontend/components/right-sidebar-wrapper";

// *************** Admin Page Components ***************
import Indexreport from '@/views/admin/pages/dashboard/index-report.vue'
import Indexmember from '@/views/admin/pages/dashboard/index-members.vue'
import Indexgroup from '@/views/admin/pages/dashboard/index-group.vue'
import Indexinvite from '@/views/admin/pages/dashboard/index-invite.vue'
import Usercount from '@/views/admin/pages/dashboard/usercount.vue'
import Table_Top from '@/views/admin/pages/users/table-top.vue'
import Company_Address from '@/views/admin/pages/settings/website-settings/company-address.vue'
import Company_Image from '@/views/admin/pages/settings/website-settings/company-image.vue'
import Company_Information from '@/views/admin/pages/settings/website-settings/company-information.vue'
import General_Notification from '@/views/admin/pages/settings/notification-settings/general-notification.vue'
import Notification_Top from '@/views/admin/pages/settings/notification-settings/notification-top.vue'
import Settingtable_Top from '@/views/admin/pages/settings/ban-address/settingtable-top.vue'
import Lantable_Top from '@/views/admin/pages/settings/language/lantable-top.vue'
import Alerts from '@/views/admin/pages/others/components/alerts.vue'
import Avatar from '@/views/admin/pages/others/components/avatar.vue'
import ComponentBreadcrumb from '@/views/admin/pages/others/components/breadcrumbs.vue'
import Buttons from '@/views/admin/pages/others/components/buttons.vue'
import Cards from '@/views/admin/pages/others/components/cards.vue'
import Dropdowns from '@/views/admin/pages/others/components/dropdowns.vue'
import Modals from '@/views/admin/pages/others/components/modals.vue'
import Pagination from '@/views/admin/pages/others/components/pagination.vue'
import Componentprogress from '@/views/admin/pages/others/components/progress.vue'
import Tabs from '@/views/admin/pages/others/components/tabs.vue'
import Typography from '@/views/admin/pages/others/components/typography.vue'
import Inputsize from '@/views/admin/pages/others/form/formbasic/inputsize.vue'
import Addressform from '@/views/admin/pages/others/form/formhorizontal/addressform'
import Basicform from '@/views/admin/pages/others/form/formhorizontal/basicform'
import Personaldetail from '@/views/admin/pages/others/form/formhorizontal/personaldetail'
import Personalinformation from '@/views/admin/pages/others/form/formhorizontal/personalinformation'
import Contexttable from '@/views/admin/pages/others/table/contexttable'

// *************** Frontend Model Components ***************
import IndexModal from '@/components/frontend/modal/index-modal.vue'
import ChatModal from '@/components/frontend/modal/chat-modal.vue'
import SettingsModal from '@/components/frontend/modal/settings-modal.vue'
import SettingsGalleryModal from '@/components/frontend/modal/settings-gallery-modal.vue'
import ChatGroupModal from '@/components/frontend/modal/chat-group-modal.vue'

// *************** Admin Model Components ***************

import Usersmodel from '@/components/admin/model/users-model.vue'
import UsersEditmodal from '@/components/admin/model/users-edit-modal.vue'
import Report_User_Model from '@/components/admin/model/report-user-model.vue'
import Invite_User_Model from '@/components/admin/model/invite-user-model.vue'
import Chat_Model from '@/components/admin/model/chat-model.vue'
import Call_Model from '@/components/admin/model/call-model.vue'
import Stories_Model from '@/components/admin/model/stories-model.vue'
import System_Model from '@/components/admin/model/system-model.vue'
import Social_Model from '@/components/admin/model/social-model.vue'
import Email_Model from '@/components/admin/model/email-model.vue'
import Sms_Model from '@/components/admin/model/sms-model.vue'
import Storage_Model from '@/components/admin/model/storage-model.vue'
import Ban_Address_Model from '@/components/admin/model/ban-address-model.vue'
import Language_Translate_Model from '@/components/admin/model/language-translate-model.vue'

//************** Breadcrumb **************/
import UserBreadcrumb from '@/components/admin/breadcrumb/userbreadcrumb.vue'
import SettingsBreadcrumb from '@/components/admin/breadcrumb/settingsbreadcrumb.vue'
import Breadcrumb from '@/components/admin/breadcrumb/breadcrumb.vue'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/css/fontawesome.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'boxicons/css/boxicons.css'
import 'boxicons/css/boxicons.min.css'
import 'vue3-tel-input/dist/vue3-tel-input.css'
import '@/assets/css/feather.css';

if (window.location.href.includes("/admin-template/")) {
    require('@/assets/css/style.css');
    require('ant-design-vue/dist/reset.css');
} else {
    require('vue3-tel-input/dist/vue3-tel-input.css');
    require('@/assets/css/app.css');
}


const app = createApp(App)

// *************** Frontend Model Components ***************

app.component('index-modal', IndexModal)
app.component('chat-modal', ChatModal)
app.component('settings-modal', SettingsModal)
app.component('settings-gallery-modal', SettingsGalleryModal)
app.component('chat-group-modal', ChatGroupModal)

// *************** Frontend Layout Components ***************

app.component('sidebar-wrapper', SidebarWrapper)
app.component('side-menu', SideMenu)
app.component('chat-sidebar', ChatSidebar)
app.component('operator-sidebar', OperatorSidebar)
app.component('settings-sidebar', SettingsSidebar)

// *************** Frontend Page Components ***************

app.component('chat-content', ChatContent)
app.component('chat-emoji', ChatEmoji)
app.component('chat-image', ChatImage)
app.component('chat-select-menu', ChatSelectMenu)
app.component('chat-right-select-menu', ChatRightSelectMenu)
app.component('chat-right-sidebar', ChatRightSidebar)
app.component('chat-right-image', ChatRightImage)
app.component('chat-right-video', ChatRightVideo)
app.component('settings-content', SettingsContent)
app.component('emoji-type', EmojiType)
app.component('click-menu', ClickMenu)
app.component('chat-star-message', ChatStarMessage)
app.component('message-right-sidebar', MessageRightSidebar)
app.component('message-info-img', MessageInfoImg)
app.component('settings-select-menu', SettingsSelectMenu)
app.component('right-sidebar-wrapper', RightSidebarWrapper)

// **************  Admin Layout  ********** //

app.component('admin-header', Admin_Header)
app.component('admin-sidebar', Admin_Sidebar)
app.component('sidesettings', SideSettings)

// **************  Admin Page Components  ********** //
app.component('index-report', Indexreport)
app.component('index-member', Indexmember)
app.component('index-invite', Indexinvite)
app.component('index-group', Indexgroup)
app.component('usercount', Usercount)
app.component('table-top', Table_Top)
app.component('company-address', Company_Address)
app.component('company-image', Company_Image)
app.component('company-information', Company_Information)
app.component('general-notification', General_Notification)
app.component('notification-top', Notification_Top)
app.component('settingtable-top', Settingtable_Top)
app.component('lantable-top', Lantable_Top)
app.component('avatar', Avatar)
app.component('alerts', Alerts)
app.component('componentbreadcrumb', ComponentBreadcrumb)
app.component('buttons', Buttons)
app.component('cards', Cards)
app.component('dropdowns', Dropdowns)
app.component('modals', Modals)
app.component('pagination', Pagination)
app.component('componentprogress', Componentprogress)
app.component('tabs', Tabs)
app.component('typography', Typography)
app.component('inputsize', Inputsize)
app.component('personaldetail', Personaldetail)
app.component('personalinformation', Personalinformation)
app.component('addressform', Addressform)
app.component('basicform', Basicform)
app.component('contexttable', Contexttable);


//************  Admin Breadcrumb ***********//
app.component('userbreadcrumb', UserBreadcrumb)
app.component('settingsbreadcrumb', SettingsBreadcrumb)
app.component('breadcrumb', Breadcrumb)

// *********** Admin Model ************//

app.component('users-model', Usersmodel)
app.component('users-edit-modal', UsersEditmodal)
app.component('report-user-model', Report_User_Model)
app.component('invite-user-model', Invite_User_Model)
app.component('chat-model', Chat_Model)
app.component('call-model', Call_Model)
app.component('stories-model', Stories_Model)
app.component('system-model', System_Model)
app.component('social-model', Social_Model)
app.component('email-model', Email_Model)
app.component('sms-model', Sms_Model)
app.component('storage-model', Storage_Model)
app.component('ban-address-model', Ban_Address_Model)
app.component('language-translate-model', Language_Translate_Model)

app.component('vue3-autocounter', Vue3Autocounter)
app.component('vue-select', VueSelect)
app.component('datepicker', DatePicker);

import Range from "@/views/frontend/components/Range";
import Image from "@/components/frontend/Image.vue";
import Typing from '@/components/frontend/Typing.vue'
app.component('Typing', Typing);
app.component('Loading', Typing);
app.component('Range', Range);
app.component('Image', Image);

import {createStore} from './store';
import {createRouter} from './router';

const store = createStore(app);
const router = createRouter(store);


app
    .use(VueTelInput)
    .use(BootstrapVue3)
    .use(BToastPlugin)
    .use(Antd)
    .use(eventHub)
    .use(VueApexCharts)
    .use(VueEasyLightbox)
    .use(store)
    .use(router)
    .mount('#app');
